"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var CustomSelectVariant = /** @class */ (function (_super) {
    __extends(CustomSelectVariant, _super);
    function CustomSelectVariant($view) {
        var _this = _super.call(this, $view) || this;
        _this.form = _this.$view.find('.custom-select-form');
        _this.bind();
        return _this;
    }
    CustomSelectVariant.prototype.bind = function () {
        var $this = this.$view.find(".js-custom-select-variant");
        var options = $(this.$view).find('div.option');
        if ($this.parent().hasClass('select')) {
            return;
        }
        $this.addClass('d-none');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');
        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option:selected').eq(0).text());
        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);
        for (var i = 0; i < options.length; i++) {
            $('<li>' + options.eq(i).html() + '</li>', {
                rel: options.eq(i).val(),
                // @ts-ignore
                selected: options.eq(i)[0].defaultSelected,
            }).appendTo($list);
        }
        var $listItems = $list.children('li');
        var defaultSelected = $listItems.filter(function (index, item) {
            return $(item).attr('selected') === 'selected';
        });
        if (defaultSelected.length > 0) {
            var val = $(defaultSelected).text();
            $styledSelect.text(val);
        }
        $styledSelect.on('click', function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });
        $listItems.on('click', function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).find(".label").text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            var selected = options.filter(function (index, option) {
                return $(option).attr('value') === $(e.currentTarget).attr('rel');
            });
            $(options).each(function (i, el) {
                // @ts-ignore
                el.defaultSelected = false;
            });
            // @ts-ignore
            $(selected)[0].defaultSelected = true;
            $('#variant-select').val($(e.target).parents('.product-form-variant-list-item').data('id'));
            $(this).parents('.select').find('select').trigger("change");
        });
        $(document).on('click', function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });
    };
    return CustomSelectVariant;
}(BaseComponent_1.default));
exports.default = CustomSelectVariant;
